import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";

async function getApprovers() {
  const data = await axiosInstance({
    url: "/approvers",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createApprovers = async (formData: any) => {
  const data = await axiosInstance({
    url: "/approvers",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateApprovers = async (formData: any) => {
  const data = await axiosInstance({
    url: `/approvers/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteApprovers = async (formData: any) => {
  const data = await axiosInstance({
    url: `/approvers/${formData}?hard=true`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useApprovers() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.approvers],
    queryFn: () => getApprovers(),
  });
  return data;
}

export function useCreateApprovers() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createApprovers(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.approvers]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateApprovers() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateApprovers(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.approvers]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteApprovers() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteApprovers(formData),
    onSuccess: (data) => {
      //   toast.success("Approvers Deleted Successfully", toastOptions);
      queryClient.invalidateQueries([queryKeys.approvers]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
